import { ReactComponent as PartyPopper } from './party-popper.svg';
import US from './us.png';
import IL from './israel.png';

export default { PartyPopper, US, IL };
